import { useSearchParams } from 'react-router-dom';
import { Provider, ProviderAvailability } from '@types';
import TimeSlotGrid from './TimeSlotGrid';
import { EmptyState } from '../';
import {
  getTimeSlotByProviderId,
  useGroupAvailableTimesByTimeOfDay,
} from '../../utils';

type Props = {
  availabilities: ProviderAvailability[];
  onSelectAvailability: (provider: Provider, time: string) => void;
  provider: Provider;
};

export default function SelectedProviderAvailability({
  availabilities,
  onSelectAvailability,
  provider,
}: Props): JSX.Element {
  const [searchParams] = useSearchParams();

  const date = searchParams.get('date') || '';

  const { times } = getTimeSlotByProviderId(availabilities, provider.id, date);
  const { morning, afternoon, evening } =
    useGroupAvailableTimesByTimeOfDay(times);
  const isEmpty = !morning.length && !afternoon.length && !evening.length;

  function handleClickTimeSlot(time: string) {
    onSelectAvailability(provider, time);
  }

  if (isEmpty) {
    return <EmptyState />;
  }

  return (
    <div className="grid gap-2">
      <TimeSlotGrid
        onClick={handleClickTimeSlot}
        times={morning}
        title="Morning"
      />
      <TimeSlotGrid
        onClick={handleClickTimeSlot}
        times={afternoon}
        title="Afternoon"
      />
      <TimeSlotGrid
        onClick={handleClickTimeSlot}
        times={evening}
        title="Evening"
      />
    </div>
  );
}
